import React, { useContext } from "react";
import "./Header.css";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router";

import Cookies from "js-cookie";
import { Context } from "../../../utils/context";
import Modallogout from "../../common/Modallogout";
library.add(fas);

function Header(props) {
  const { setUserData,  setSignin } = useContext(Context);

  const navigate = useNavigate();

  const LogOut = async () => {
    setModalShow(false);
    Cookies.remove("tradex_security", { path: "/" });
    await setUserData("");
      await setSignin(false);
    navigate("/");
  };
  const [modalShow, setModalShow] = React.useState(false);
  return (
    <>
      <section className="header headerr">
        <Navbar expand="md" className="bg-body-tertiary">
          <Navbar.Brand>
            <div className="header-text">
              <div className="d-flex">
                {props.icon && (
                  <span className="header-icon" aria-hidden="true">
                    <FontAwesomeIcon icon={props.icon} />
                  </span>
                )}
                <div className="header-titles">
                  {props.title && (
                    <nav aria-label="Breadcrumb">
                      <ol className="header-crumbs">
                        <li>BlueChart</li>
                        <li aria-current="page">{props.title}</li>
                      </ol>
                    </nav>
                  )}
                  <h1>{props.title}</h1>
                </div>
              </div>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <div className="header-icons">
                <button
                  type="button"
                  className="header-logout deskviewlogout"
                  onClick={() => setModalShow(true)}
                  aria-label="Log out"
                  title="Log out"
                >
                  <FontAwesomeIcon icon="fa-solid fa-power-off" />
                  <span>Logout</span>
                </button>
              </div>
            </Nav>
          </Navbar.Collapse>

          <button
            type="button"
            className="header-logout mobileviewlogout"
            onClick={LogOut}
            aria-label="Log out"
            title="Log out"
          >
            <FontAwesomeIcon icon="fa-solid fa-power-off" />
          </button>
        </Navbar>

        <Modallogout
          LogOut={LogOut}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </section>
    </>
  );
}

export default Header;
